<template>
  <div>
    <section v-if="selectedLayoutId" class="_styles-section">

      <div class="pb-4">
        <TextField 
          v-model="layout[getIndexOfSelectedLayout].label"
          label="Nome do estilo"
          :showBorder="true"
        />
      </div>

      <form-section label="Título" v-model="isExpanded.title">
        <v-row no-gutters>
          <v-col cols="9" class="_pr">
            <Select
              v-model="layout[getIndexOfSelectedLayout].title.font"
              placeholder="Fonte"
              :items="fontsType"
              :showBorder="true"
            />
          </v-col>
          <v-col cols="3">
            <TextField 
              v-model="fontSize.title"
              placeholder="px"
              type="number"
              :minValueForNumber="10"
              @input="updateSize($event, layout[getIndexOfSelectedLayout].title)"
            />          
          </v-col>
          <v-col cols="9" class="_pt _pr">
            <ColorPickerV2 :colorSelected="layout[getIndexOfSelectedLayout].title" type="color" title=""/>   
          </v-col>
          <v-col cols="3" class="_pt">
            <FormBoldItalic v-model="layout[getIndexOfSelectedLayout].title"/> 
          </v-col>
        </v-row>        
      </form-section>

      <form-section label="Subtítulo" v-model="isExpanded.subtitle">
        <v-row no-gutters>
          <v-col cols="9" class="_pr">
            <Select
              v-model="layout[getIndexOfSelectedLayout].subtitle.font"
              placeholder="Fonte"
              :items="fontsType"
              :showBorder="true"
            />
          </v-col>
          <v-col cols="3">
            <TextField 
              v-model="fontSize.subtitle"
              placeholder="px"
              solo
              type="number"
              :minValueForNumber="10"
              @input="updateSize($event, layout[getIndexOfSelectedLayout].subtitle)"
            />             
          </v-col>
          <v-col cols="9" class="_pt _pr">
            <ColorPickerV2 :colorSelected="layout[getIndexOfSelectedLayout].subtitle" type="color" title=""/> 
          </v-col>
          <v-col cols="3" class="_pt">
            <FormBoldItalic v-model="layout[getIndexOfSelectedLayout].subtitle"/>           
          </v-col>
        </v-row>        
      </form-section>

      <form-section label="Texto" v-model="isExpanded.text">
        <v-row no-gutters>
          <v-col cols="9" class="_pr">
            <Select
              v-model="layout[getIndexOfSelectedLayout].text.font"
              placeholder="Fonte"
              :items="fontsType"
              :showBorder="true"
            />
          </v-col>
          <v-col cols="3">
            <TextField 
              v-model="fontSize.text"
              placeholder="px"
              type="number"
              :minValueForNumber="10"
              @input="updateSize($event, layout[getIndexOfSelectedLayout].text)"
            />               
          </v-col>
          <v-col cols="9" class="_pt _pr">
            <ColorPickerV2 :colorSelected="layout[getIndexOfSelectedLayout].text" type="color" title=""/>   
          </v-col>         
          <v-col cols="3" class="_pt">
            <FormBoldItalic v-model="layout[getIndexOfSelectedLayout].text"/>                   
          </v-col>          
        </v-row>        
      </form-section>

      <form-section label="Botão" v-model="isExpanded.button">
        <v-row no-gutters>
          <v-col cols="6" class="_pr-">
            <ColorPickerV2 :colorSelected="layout[getIndexOfSelectedLayout].button" type="color" title="Cor do Texto"/>   
          </v-col>
          <v-col cols="6" class="_pl-">
            <ColorPickerV2 :colorSelected="layout[getIndexOfSelectedLayout].button" type="background-color" title="Cor do fundo" />   
          </v-col>
          <v-col cols="6" class="_pt_plus _pr-">
            <TextField 
              v-model="fontSize.buttonBorderRadius"
              label="Arredondamento"
              placeholder="px"
              type="number"
              :minValueForNumber="0"
              @input="updateSize($event, layout[getIndexOfSelectedLayout].button, 'border')"
            />
          </v-col>
        </v-row>        
      </form-section>
    
      <form-section label="Fundo" v-model="isExpanded.button" :divider="false">
        <v-row no-gutters>
          <v-col cols="12">
            <BgSelector v-model="layout[getIndexOfSelectedLayout].bg" :availableTypes="['color', 'image', 'video']"></BgSelector>   
          </v-col>
        </v-row>        
      </form-section>

      <div 
        v-if="layout[getIndexOfSelectedLayout].temp && !isCreated" 
        class="actions pt-8"
      >
        <Button
          outlined
          label="Cancelar"
          text-color="bt_color"
          height="40px"
          @click="handleCancelStyle"
        />
        <Button
          label="Criar estilo"
          height="40px"
          @click="handleCreateStyle"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from '../../../_v2/ui/Button.vue'
import Select from '../../../_v2/ui/Select.vue'
import TextField from '../../../_v2/ui/TextField.vue'
import ColorPickerV2 from '../../../_v2/ui/ColorPickerV2.vue'
import FormSection from '../../../_v2/utils/FormSection.vue'
import FormBoldItalic from '../../../_v2/utils/FormBoldItalic.vue'
import FormAlignment from '../../../_v2/utils/FormAlignment.vue'
import BgSelector from '../../../_v2/utils/BgSelector.vue'

export default {
  components: { ColorPickerV2, Button, Select, TextField, FormSection, FormBoldItalic, BgSelector, FormAlignment },
  props: {
    layout: { type: Array }
  },

  data() {
    return {
      fontsType: ["Inter", "Montserrat", "Roboto", "Work Sans"],
      fontSize: {
        title: '',
        subtitle: '',
        text: '',
        buttonBorderRadius: ''
      },
      isCreated: false,
      isExpanded: {default: true, title: true, subtitle: true, text: true, button: true, bg: true}
    };
  },

  computed: {
    ...mapGetters(["saveConfig", "layoutStyle", "infos"]),

    selectedLayoutId: {
      get () { return this.layoutStyle.id },
      set (v) { this.layoutStyle.id = v }
    },

    getIndexOfSelectedLayout () {
      return this.layout.findIndex(layout => layout.id === this.selectedLayoutId)
    }
  },

  mounted () {
    this.formatFontSize()
  },

  beforeDestroy () {
    this.infos.layout = this.infos.layout.filter(layout => layout.temp !== true) // remove unsave style
  },

  methods: {
    formatFontSize() {
      this.fontSize.title = this.layout[this.getIndexOfSelectedLayout].title["font-size"].split("px")[0]
      this.fontSize.subtitle = this.layout[this.getIndexOfSelectedLayout].subtitle["font-size"].split("px")[0]
      this.fontSize.text = this.layout[this.getIndexOfSelectedLayout].text["font-size"].split("px")[0]
      this.fontSize.buttonBorderRadius = this.layout[this.getIndexOfSelectedLayout].button["border-radius"].split("px")[0]
    },

    updateSize(event, type, border) {
      let model = "";
      model = event + "px";
      if (border === "border") type["border-radius"] = model;
      else type["font-size"] = model;
    },

    handleCancelStyle () {
      this.$emit('cancelNewStyle')
    },

    handleCreateStyle () {
      const index = this.getIndexOfSelectedLayout
      const style = this.layout[index]
      if (style.temp) delete style.temp
      this.isCreated = true
      this.$emit('onCreateNewStyle')
    }
  }
};
</script>

<style scoped>
* {
  font-family: Inter, sans-serif !important;
}

.actions {
  display: flex;
  justify-content: end;
  gap: 12px
}
</style>
